export default __webpack_public_path__ + "static/media/DegreeLink.02f4c719.png";